import { useEffect } from "react";
import { WORKSPACE_MODE_REQUEST_EVENT } from "@/lib/workspaceModeNavigation";
import {
  consumePendingServiceSetupOffering,
  resolveServiceSetupOfferingId,
} from "@/lib/service/pendingServiceSetupOpen";
import type { ServiceOffering } from "@/lib/service/types";

/** Opens a specific service detail when deep-linked via `openServiceSetup`. */
export function useServiceSetupDeepLink(args: {
  offerings: ServiceOffering[];
  onOpenOffering: (offeringId: string) => void;
  onClearWizard: () => void;
}) {
  const { offerings, onOpenOffering, onClearWizard } = args;

  useEffect(() => {
    function applyPending() {
      const pending = consumePendingServiceSetupOffering();
      if (!pending.offeringId && !pending.offeringSlug) return;
      const offeringId = resolveServiceSetupOfferingId(offerings, pending);
      if (!offeringId) return;
      onClearWizard();
      onOpenOffering(offeringId);
    }

    applyPending();

    function onModeRequest(ev: Event) {
      const detail = (ev as CustomEvent<{ mode?: string }>).detail;
      if (detail?.mode === "serviceDefinitions") applyPending();
    }

    window.addEventListener(WORKSPACE_MODE_REQUEST_EVENT, onModeRequest);
    return () => window.removeEventListener(WORKSPACE_MODE_REQUEST_EVENT, onModeRequest);
  }, [offerings, onClearWizard, onOpenOffering]);
}
